import AbandonedCartToasts from './AbandonedCartToasts';

export default AbandonedCartToasts;
